var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-67"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 398.49,
    width: 33.21,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.33,
    y: 397.5,
    width: 54.1,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.67,
    y: 389.21,
    width: 19.11,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.12,
    y: 390.89,
    width: 14.78,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 390.89,
    width: 34.74,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.33,
    y: 395.11,
    width: 45.45,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.7,
    y: 199.43,
    width: 12.07,
    height: 176.85,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.88,
    y: 376.28,
    width: 66.88,
    height: 6.1,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.77,
    y: 199.43,
    width: 61.18,
    height: 176.85,
    transform: "translate(394.72 575.71) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.3,
    y: 291.52,
    width: 48.13,
    height: 31.58,
    transform: "translate(394.72 614.62) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.3,
    y: 332.85,
    width: 48.13,
    height: 31.58,
    transform: "translate(394.72 697.28) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.17,
    y: 305.14,
    width: 16.38,
    height: 4.33,
    rx: 1.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.17,
    y: 346.48,
    width: 16.38,
    height: 4.33,
    rx: 1.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.3,
    y: 209.18,
    width: 48.13,
    height: 31.58,
    transform: "translate(394.72 449.94) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.3,
    y: 250.19,
    width: 48.13,
    height: 31.58,
    transform: "translate(394.72 531.95) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.17,
    y: 222.81,
    width: 16.38,
    height: 4.33,
    rx: 1.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.17,
    y: 263.81,
    width: 16.38,
    height: 4.33,
    rx: 1.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.59,
    y: 199.43,
    width: 36.24,
    height: 176.85,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.3,
    y: 376.28,
    width: 90.52,
    height: 6.1,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.82,
    y: 199.43,
    width: 61.18,
    height: 176.85,
    transform: "translate(260.83 575.71) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.78,183.64a15.8,15.8,0,1,1-28.42-9.47h25.25A15.68,15.68,0,0,1,155.78,183.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.23,185.84a13.59,13.59,0,1,1-24.45-8.15H129.5A13.52,13.52,0,0,1,132.23,185.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.35,
    y: 291.52,
    width: 48.13,
    height: 31.58,
    transform: "translate(260.83 614.62) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.35,
    y: 332.85,
    width: 48.13,
    height: 31.58,
    transform: "translate(260.83 697.28) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.22,
    y: 305.14,
    width: 16.38,
    height: 4.33,
    rx: 1.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.22,
    y: 346.48,
    width: 16.38,
    height: 4.33,
    rx: 1.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.35,
    y: 209.18,
    width: 48.13,
    height: 31.58,
    transform: "translate(260.83 449.94) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.35,
    y: 250.19,
    width: 48.13,
    height: 31.58,
    transform: "translate(260.83 531.95) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.22,
    y: 222.81,
    width: 16.38,
    height: 4.33,
    rx: 1.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.22,
    y: 263.81,
    width: 16.38,
    height: 4.33,
    rx: 1.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.71,
    y: 135.71,
    width: 125.26,
    height: 10.77,
    transform: "translate(316.68 282.19) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.01,
    cy: 120.72,
    r: 15.1,
    transform: "translate(-16.81 32.96) rotate(-9.22)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.78,
    y: 135.71,
    width: 24.93,
    height: 10.77,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.54,
    y: 106.63,
    width: 27.32,
    height: 29.08,
    transform: "translate(338.41 242.34) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.86,
    y: 106.63,
    width: 7,
    height: 29.08,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.09,
    y: 98.41,
    width: 23.41,
    height: 37.3,
    transform: "translate(317.6 234.12) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.51,
    y: 98.41,
    width: 4.77,
    height: 37.3,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.55,
    y: 102.15,
    width: 20.52,
    height: 33.56,
    transform: "translate(299.61 237.86) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.07,
    y: 102.15,
    width: 5.93,
    height: 33.56,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.7,
    y: 106.63,
    width: 27.32,
    height: 29.08,
    transform: "translate(280.72 242.34) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.02,
    y: 106.63,
    width: 3.95,
    height: 29.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.06,
    y: 96.39,
    width: 18.7,
    height: 39.32,
    transform: "translate(270.81 232.1) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.76,
    y: 96.39,
    width: 5.41,
    height: 39.32,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.95 99.86 126.06 99.86 131.87 135.71 107.76 135.71 101.95 99.86",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.03 99.86 126.06 99.86 131.87 135.71 138.84 135.71 133.03 99.86",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.84,
    y: 95.08,
    width: 27.32,
    height: 40.63,
    transform: "translate(209 230.79) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.16,
    y: 95.08,
    width: 7.9,
    height: 40.63,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.67,
    y: 96.39,
    width: 143.36,
    height: 107.02,
    transform: "translate(714.69 299.8) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.84,
    y: 96.39,
    width: 6.83,
    height: 107.02,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.68,211.94c11.94,6.78,23,21.18,24.18,32.8q5.4-13.44,11.91-26.41a22.66,22.66,0,0,1-4.27,2.38c-22,10.41-23.05-26.59-9-50.58,11,8.21,20.22,23.92,19.88,35.62q7.05-12.7,15.17-24.83a22.61,22.61,0,0,1-4.55,1.85c-23.14,7.67-19.56-29.29-2.42-51.51,9.88,9.53,17,26.32,15.18,37.94q8-11,16.93-21.33c-13.41-3.87-1-28,15-38.87,6,15.28,5.61,40.07-10.69,39.51q-3.42,3.93-6.72,8c10.93-4.85,28.28.33,38.78,9.1-15.52,14.65-45.05,29.95-47.72,6.94a20.24,20.24,0,0,1,.16-4.85q-8.72,11.57-16.37,23.77c10.18-6.11,28-3.07,39.52,4.31-13.42,16.29-40.74,35-46.32,12.6a20.09,20.09,0,0,1-.46-4.81Q364.73,216,358.67,229c9.32-7.29,27.35-6.45,39.7-.56-11.22,17.71-36,39.63-44.32,18.12a19.68,19.68,0,0,1-1.06-4.7q-5.52,13.22-9.92,26.87c8.35-8.38,26.33-9.77,39.32-5.46-8.91,18.92-30.8,43.78-41.72,23.46l0,0a3.82,3.82,0,0,0-5.71-1.47l-.63.46q3.69-14,8.54-27.67a23.08,23.08,0,0,1-3.94,2.89C318.39,274,312.74,237.38,323.68,211.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,232c-9.8,3.91-19.85,13.83-22.05,22.71q-2.52-11-5.95-21.82a17.14,17.14,0,0,0,2.95,2.33c15.4,10.55,20.48-18,12.6-38.22-9.25,5.13-18,16.27-19.12,25.38q-3.86-10.63-8.6-21a18,18,0,0,0,3.22,1.95c16.61,8.55,18.16-20.52,7.77-39.69-8.56,6.28-15.89,18.5-15.84,27.72q-4.8-9.4-10.33-18.45c10.58-1.49,3.94-21.59-6.84-31.84-6.29,11.18-8.86,30.45,3.53,31.86q2.13,3.42,4.16,6.92c-7.7-5-21.41-2.93-30.36,2.68,10.05,13.11,30.59,28.31,35.26,10.76a16.16,16.16,0,0,0,.44-3.78q5.25,10,9.63,20.29c-7-5.89-20.8-5.54-30.35-1.12,8.26,14.15,26.74,31.75,33.54,15a15.89,15.89,0,0,0,.9-3.68q4,10.48,7,21.25c-6.21-6.7-19.92-8.08-29.93-4.91,6.43,15,22.62,34.8,31.39,19.06a16,16,0,0,0,1.35-3.53q2.64,10.88,4.39,22c-5.34-7.44-18.77-10.55-29.08-8.67,4.56,15.68,18.23,37.43,28.82,22.9l0,0a2.9,2.9,0,0,1,4.49-.5l.42.43q-1.17-11.28-3.26-22.42a17.53,17.53,0,0,0,2.64,2.69C358.16,280.67,366.65,252.94,361.31,232Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.33,274.28s-.94,108.12-36.77,108.12-36.77-108.12-36.77-108.12Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-67"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-67",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.89,315.46a3.21,3.21,0,0,0-3.2,3.35l.13,2.77A5.32,5.32,0,0,0,98.9,326h.93l.92,3.07a4.85,4.85,0,0,0,4.64,3.45h77.38a9.93,9.93,0,0,0-3.4-7.49,2,2,0,0,0,.06-.23l.43-5a4,4,0,0,0-4-4.37Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.89,315.46a3.21,3.21,0,0,0-3.2,3.35l.13,2.77A5.32,5.32,0,0,0,98.9,326h.93l.92,3.07a4.85,4.85,0,0,0,4.64,3.45h77.38a9.93,9.93,0,0,0-3.4-7.49,2,2,0,0,0,.06-.23l.43-5a4,4,0,0,0-4-4.37Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.59 411.23 125.19 411.23 129.85 332.51 133.25 332.51 128.59 411.23",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.59 411.23 125.19 411.23 129.85 332.51 133.25 332.51 128.59 411.23",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.16 411.23 182.56 411.23 177.91 332.51 174.51 332.51 179.16 411.23",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.16 411.23 182.56 411.23 177.91 332.51 174.51 332.51 179.16 411.23",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.32 411.23 103.92 411.23 108.57 332.51 111.97 332.51 107.32 411.23",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.32 411.23 103.92 411.23 108.57 332.51 111.97 332.51 107.32 411.23",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.89 411.23 161.29 411.23 156.64 332.51 153.24 332.51 157.89 411.23",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.89 411.23 161.29 411.23 156.64 332.51 153.24 332.51 157.89 411.23",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.22 404.04 203.37 404.1 204.68 385.29 196.53 385.24 195.22 404.04",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.14,401.88l-9.14-.06a.57.57,0,0,0-.61.55l-.49,7.23a1.44,1.44,0,0,0,1.41,1.45c3.19,0,4.71-.21,8.73-.18,2.47,0,11,.14,14.38-.26s2.9-3.75,1.42-3.88c-6.61-.6-12-2.52-14.3-4.34A2.26,2.26,0,0,0,204.14,401.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.53 385.24 204.68 385.29 204 394.99 195.85 394.93 196.53 385.24",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.45,283.81s60.13,3.1,60.22,26.44c.13,33.54-7.69,79.41-7.69,79.41L193.09,389s-4.05-46.32-3.75-72.5c-16.44-4.71-55.06,3-60.09-10.62a44.73,44.73,0,0,1-1.89-22Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.45,283.81s60.13,3.1,60.22,26.44c.13,33.54-7.69,79.41-7.69,79.41L193.09,389s-4.05-46.32-3.75-72.5c-16.44-4.71-55.06,3-60.09-10.62a44.73,44.73,0,0,1-1.89-22Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.3 393.19 208.54 392.95 209.56 386.41 191.88 386.13 191.3 393.19",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,403.31a9.79,9.79,0,0,1-2.16-.3.18.18,0,0,1-.14-.15.17.17,0,0,1,.07-.19c.27-.18,2.58-1.74,3.57-1.34a.7.7,0,0,1,.44.54,1,1,0,0,1-.25,1A2.15,2.15,0,0,1,207,403.31Zm-1.64-.57c1.45.3,2.53.26,2.91-.12a.67.67,0,0,0,.14-.67.34.34,0,0,0-.21-.27C207.68,401.46,206.32,402.14,205.37,402.74Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,403a.15.15,0,0,1-.09,0,.23.23,0,0,1-.1-.15c0-.1-.17-2.44.65-3.23a1,1,0,0,1,.81-.26.72.72,0,0,1,.68.58c.19.89-1,2.58-1.85,3.06Zm1.13-3.29a.52.52,0,0,0-.4.17c-.5.46-.57,1.8-.56,2.58.72-.6,1.53-1.88,1.41-2.46,0-.12-.08-.25-.36-.28Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.17,220.76c1.39,3.55,2.84,7.27,4.37,10.86s3.08,7.19,4.71,10.71,3.36,7,5.21,10.2c.93,1.62,1.91,3.18,2.9,4.6a22,22,0,0,0,3,3.56l-1.44-.84a3.54,3.54,0,0,0-1.68-.22,3,3,0,0,0-1.06.33c-.37.23-.21.22,0,.07a9.58,9.58,0,0,0,1.59-1.88,52.53,52.53,0,0,0,3.32-5.77c1.07-2.07,2.09-4.23,3.09-6.4s2-4.41,3-6.58L196,241c-.34,2.55-.84,5-1.37,7.47s-1.22,4.92-2,7.39a48.84,48.84,0,0,1-3,7.49,20.57,20.57,0,0,1-2.7,4.08,9.89,9.89,0,0,1-2.9,2.32,7.52,7.52,0,0,1-6.3.38l-.74-.29-.69-.56a32.7,32.7,0,0,1-5.12-5.28,62,62,0,0,1-3.77-5.39,122.36,122.36,0,0,1-6.15-11c-1.87-3.7-3.56-7.44-5.17-11.21S153,228.93,151.58,225Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.66,215.9c9,4.61,12.43,20.35,12.43,20.35L155.35,248.1c-5.72-5.41-10.79-17.18-11.73-22.55C142.18,217.32,150,210.44,160.66,215.9Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.37,229.36c3,3.53,4.17,8.81,4.16,14.62l-6.18,4.12c-5.55-5.25-10.5-16.5-11.63-22C149,225.22,155.09,226.65,157.37,229.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.29 408.65 219.36 404.62 209.38 388.61 202.31 392.65 212.29 408.65",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.55,402.8l-7.94,4.53a.58.58,0,0,0-.25.78l3.2,6.51a1.45,1.45,0,0,0,2,.55c2.73-1.63,4-2.55,7.45-4.54,2.15-1.23,9.56-5.17,12.53-6.86s1.21-4.58-.2-4.13c-6.32,2-12.4,3.33-15.29,2.9A2.27,2.27,0,0,0,218.55,402.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.31 392.65 209.38 388.62 214.78 397.29 207.72 401.33 202.31 392.65",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,283.81s48.22,2.1,51.57,25.2c3.66,25.29,26,83.71,26,83.71l-12.94,7.39s-36.53-54.72-38.5-80.83c-14.82,3-51.74,2.15-56.77-11.49-4.12-11.16.88-23.56.88-23.56Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,283.81s48.22,2.1,51.57,25.2c3.66,25.29,26,83.71,26,83.71l-12.94,7.39s-36.53-54.72-38.5-80.83c-14.82,3-51.74,2.15-56.77-11.49-4.12-11.16.88-23.56.88-23.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.5 401.84 218.97 392.45 216.01 385.24 198.3 396.19 202.5 401.84",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.76,402.6a10.53,10.53,0,0,1-2,.82.19.19,0,0,1-.2-.06.18.18,0,0,1,0-.2c.14-.29,1.36-2.8,2.41-3a.7.7,0,0,1,.65.25,1,1,0,0,1,.31,1A2.2,2.2,0,0,1,221.76,402.6Zm-1.72.32c1.41-.47,2.32-1,2.46-1.55a.68.68,0,0,0-.22-.66.35.35,0,0,0-.31-.13C221.4,400.67,220.57,401.93,220,402.92Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.77,403.4a.16.16,0,0,1-.09,0,.19.19,0,0,1-.16-.08c-.06-.08-1.38-2-1.06-3.12a.94.94,0,0,1,.57-.63.72.72,0,0,1,.88.16c.6.68.39,2.75-.07,3.57A.16.16,0,0,1,219.77,403.4ZM219.1,400a.53.53,0,0,0-.27.35c-.2.65.41,1.85.81,2.51.32-.87.38-2.4,0-2.84a.35.35,0,0,0-.45-.06Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.57,242.12l.49-9,9.27,3.36s-2.85,8.53-5.63,8.42Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.34 227.2 202.12 231.71 199.33 236.48 190.06 233.12 196.34 227.2",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.07,212.28c.81-2.16,4.55-4.29,6.85-4.27l1.52,0c2.65.06,6,.21,9.17.59a160.78,160.78,0,0,1,18.24,3.06,78.29,78.29,0,0,1,7.54,2.44c2.7,1,4.27,1.78,4.27,1.78s-4.5,47.56-5.26,68.33H109.72c-1.57-8.92-.55-25.26-.67-41.38C109,233.15,109.76,221.09,113.07,212.28Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.56,229.54c-.42,4.58-.54,9.16-.51,13.31q0,2.93,0,5.85c2.69-3.7,4.38-7.57,4.4-11.34C113.47,235.05,111.9,232.09,109.56,229.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,224.73c-.92,1.1-2,2.43-2.93,3.67s-2,2.54-2.88,3.84c-1.88,2.59-3.67,5.23-5.34,7.89a78.47,78.47,0,0,0-4.4,8.11,30.6,30.6,0,0,0-2.51,7.9l0,.23,0,.12s0,.12,0,0a3.1,3.1,0,0,0-.07-.71,2.83,2.83,0,0,0-.6-1.22c-.23-.24-.31-.27-.33-.26a1.43,1.43,0,0,0,.26.18,12.86,12.86,0,0,0,3.42,1.06,67.68,67.68,0,0,0,9.26,1c3.23.19,6.51.24,9.81.27s6.65,0,9.92,0l.78,6.06a137.67,137.67,0,0,1-20.43,3,66.54,66.54,0,0,1-10.83-.06,23.24,23.24,0,0,1-6.31-1.44,11.37,11.37,0,0,1-2-1,9.9,9.9,0,0,1-2.19-1.94A8.09,8.09,0,0,1,92.93,258a7.8,7.8,0,0,1-.17-2v-.48l0-.4a38.15,38.15,0,0,1,2.76-11.45c.68-1.73,1.43-3.41,2.22-5.05s1.67-3.21,2.55-4.76A103.58,103.58,0,0,1,106.1,225c1-1.43,2.08-2.83,3.17-4.21s2.15-2.7,3.42-4.14Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.12,208c6.94.25,12.57,5.49,8.16,15.79-2.89,6.75-13.46,18-13.46,18l-14.32-14C104.74,217.55,111.91,207.75,119.12,208Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,187.24l4.54,5.25,6.18,7.17a23.9,23.9,0,0,0-.94,2.82c-1,3.83-.62,7.55,4.88,9.86,0,0,4.75,6.21-6.54,4.48s-13-7.63-13-7.63C133.41,205.67,133.7,193.83,133.3,187.24Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,199.66a23.9,23.9,0,0,0-.94,2.82c-2.58-1-5.69-4.44-5.6-7.24a12.51,12.51,0,0,1,.36-2.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.73,182.36c1,4.29-1.18,8.45-4.85,9.3s-7.46-1.93-8.46-6.21,1.18-8.45,4.86-9.3S157.74,178.08,158.73,182.36Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.73,182.36c1,4.29-1.18,8.45-4.85,9.3s-7.46-1.93-8.46-6.21,1.18-8.45,4.86-9.3S157.74,178.08,158.73,182.36Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.65,177.74c.43,8.74.23,13.86,4.57,18.54a11.37,11.37,0,0,0,19.49-5c2-7.74.95-20.73-7.52-24.6A11.51,11.51,0,0,0,132.65,177.74Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.64,183.82c-1.62-4.17,10.81-.48,5.62-11.89,5.19,2.62,11.64,2.2,13.5-.18,3.68-4.73,2.61,8,7.55,2.32,1.9-2.2-1.86-3.75-1.36-10.29.41-5.27-7.37-10.46-12.85-5.35s-8.51,3.51-12.13,2.86-6.16,4-3.66,6.91c-7.85.3-10.91,2.06-6.21,5.45s1.06,4.76,2,8.61C126.4,188,136.65,194.17,132.64,183.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.38,185.39a9.18,9.18,0,0,0,4.9,4.3c2.73,1,4-1.48,3.19-4.2-.74-2.45-3.05-5.91-5.76-5.7S128.07,182.91,129.38,185.39Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.25,182.36c1,4.29-1.17,8.45-4.85,9.3s-7.46-1.93-8.45-6.21,1.18-8.45,4.85-9.3S136.26,178.08,137.25,182.36Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.7,177.54a1.06,1.06,0,0,1-1-.72c-.1-.28-2.34-6.86.8-11.55,1.77-2.65,4.84-4.11,9.13-4.35a1.07,1.07,0,1,1,.12,2.13c-3.58.2-6.09,1.35-7.47,3.41-2.55,3.81-.58,9.59-.56,9.65a1.08,1.08,0,0,1-.66,1.37A1.12,1.12,0,0,1,129.7,177.54Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,183.46c.58,2.51-.69,4.94-2.84,5.44s-4.37-1.13-5-3.64.69-4.94,2.84-5.44S132.4,181,133,183.46Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,180.93c0,.71.36,1.3.83,1.32s.84-.53.85-1.24-.36-1.31-.82-1.33S147,180.22,147,180.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,181.31c0,.71.36,1.3.82,1.32s.85-.53.86-1.24-.36-1.31-.82-1.33S155,180.6,155,181.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.53,181.18a22.68,22.68,0,0,0,2.45,5.48,3.38,3.38,0,0,1-2.9.21Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.49,190.29a6.12,6.12,0,0,1-4.37-1.95.22.22,0,0,1,0-.3.21.21,0,0,1,.29,0,5.86,5.86,0,0,0,4.84,1.78.2.2,0,0,1,.23.18.21.21,0,0,1-.19.23A7.86,7.86,0,0,1,151.49,190.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.07,178.41a.42.42,0,0,1-.18-.11.41.41,0,0,1,0-.59,4.06,4.06,0,0,1,3.57-1.19.42.42,0,0,1,.32.5.42.42,0,0,1-.5.32,3.15,3.15,0,0,0-2.79,1A.42.42,0,0,1,144.07,178.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.53,178.67a.39.39,0,0,1-.34-.19,3.47,3.47,0,0,0-2.6-1.65.41.41,0,0,1-.4-.43.43.43,0,0,1,.43-.41h0a4.37,4.37,0,0,1,3.27,2,.43.43,0,0,1-.13.58A.46.46,0,0,1,157.53,178.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.91,256.91l7.2-2.15-1.21,8.71s-7.12,2-7.85-1.75Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.45 257.67 147.24 263.75 139.9 263.47 141.1 254.76 149.45 257.67",
    style: {
      fill: "#ffc3bd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.09,412.62h5.24a4.35,4.35,0,0,1,2.69,1l3.1,2.47c.27.21.17.86-.13.86H252.42c-.3,0-.39-.65-.12-.86l3.1-2.47A4.35,4.35,0,0,1,258.09,412.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.69,
    y: 340.79,
    width: 142.03,
    height: 4.59,
    transform: "translate(603.8 82.38) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.04,
    y: 271.45,
    width: 3.34,
    height: 4.59,
    transform: "translate(534.45 13.04) rotate(90)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.75,
    y: 269.05,
    width: 251.93,
    height: 4.12,
    transform: "translate(521.42 542.22) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.12,
    y: 269.05,
    width: 88.56,
    height: 4.12,
    transform: "translate(684.79 542.22) rotate(180)",
    style: {
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.4,249.1h0a5.47,5.47,0,0,1-7.7,0l-11-11a5.47,5.47,0,0,1,0-7.7h0a5.47,5.47,0,0,1,7.7,0l11,11A5.47,5.47,0,0,1,201.4,249.1Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.28,257.49v-1.07a3.46,3.46,0,0,0,3.45-3.46v-5.28h1.07V253A4.53,4.53,0,0,1,200.28,257.49Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.23,245.27l6.67,6.67a6.6,6.6,0,0,0,9.34-9.34l-6.67-6.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,247.68a2.33,2.33,0,1,1-2.28-2.77A2.55,2.55,0,0,1,197.7,247.68Z",
    style: {
      fill: "#2F55D4",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.13,247.68a2.32,2.32,0,1,1-2.28-2.77A2.55,2.55,0,0,1,197.13,247.68Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.81,267.75h-1.07V257.49h-.9a4.53,4.53,0,0,1-4.52-4.53v-5.28h1.07V253a3.46,3.46,0,0,0,3.45,3.46h2Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.11 269.05 195.44 269.05 196.96 267.24 203.59 267.24 205.11 269.05",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.19,249.1h0a5.46,5.46,0,0,0,7.69,0l11-11a5.46,5.46,0,0,0,0-7.7h0a5.46,5.46,0,0,0-7.69,0l-11,11A5.46,5.46,0,0,0,319.19,249.1Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.77,257.49v-1.07a3.46,3.46,0,0,0,3.45-3.46v-5.28h1.07V253A4.53,4.53,0,0,1,323.77,257.49Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.36,245.27l-6.67,6.67a6.6,6.6,0,1,1-9.34-9.34l6.67-6.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.19,247.68a2.32,2.32,0,1,1-2.28-2.77A2.55,2.55,0,0,1,321.19,247.68Z",
    style: {
      fill: "#2F55D4",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.62,247.68a2.32,2.32,0,1,1-2.28-2.77A2.55,2.55,0,0,1,320.62,247.68Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.3,267.75h-1.07V257.49h-.9a4.53,4.53,0,0,1-4.52-4.53v-5.28h1.07V253a3.46,3.46,0,0,0,3.45,3.46h2Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.6 269.05 318.94 269.05 320.45 267.24 327.08 267.24 328.6 269.05",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,266.82H173.17a2.23,2.23,0,0,0-2.23,2.23H272.59A2.23,2.23,0,0,0,270.36,266.82Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,266.82H173.17a2.23,2.23,0,0,0-2.23,2.23H272.59A2.23,2.23,0,0,0,270.36,266.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.53,266.82H173.17a2.23,2.23,0,0,0-2.23,2.23h32.82A2.23,2.23,0,0,0,201.53,266.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.43,217.13h-68a4.93,4.93,0,0,0-4.64,4l-7.26,41.79a3.24,3.24,0,0,0,3.26,3.95h68a4.91,4.91,0,0,0,4.64-3.95l7.27-41.79A3.24,3.24,0,0,0,279.43,217.13Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.43,217.13h-68a4.93,4.93,0,0,0-4.64,4l-7.26,41.79a3.24,3.24,0,0,0,3.26,3.95h68a4.91,4.91,0,0,0,4.64-3.95l7.27-41.79A3.24,3.24,0,0,0,279.43,217.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.52,264.94l7.85-45.18a.94.94,0,0,0-1.61-.81,4.76,4.76,0,0,0-1,2.13l-7.26,41.79a3.47,3.47,0,0,0,.34,2.3A.9.9,0,0,0,201.52,264.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,242c-.54,5.21-4.15,9.43-8.05,9.43s-6.62-4.22-6.08-9.43,4.15-9.42,8.06-9.42S250.57,236.77,250,242Z",
    style: {
      fill: "#2F55D4",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.65,227.33c1,1.34,1.88,2.52,2.75,3.81s1.7,2.55,2.52,3.85c1.65,2.58,3.16,5.25,4.6,8a73.65,73.65,0,0,1,6.79,17.76,42.76,42.76,0,0,1,.77,5.06,18.06,18.06,0,0,1-.57,6.06,35.37,35.37,0,0,1-4.06,9.27,70.7,70.7,0,0,1-11.67,14.37l-4.59-3.86,2.17-3.63c.71-1.24,1.39-2.49,2.07-3.72,1.34-2.49,2.59-5,3.63-7.46a30,30,0,0,0,2.16-7.13,7.94,7.94,0,0,0,0-2.68,33.55,33.55,0,0,0-.81-3.6,72.77,72.77,0,0,0-6.51-14.72c-1.34-2.43-2.81-4.81-4.29-7.19-.74-1.18-1.51-2.36-2.3-3.52s-1.59-2.35-2.32-3.37Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.27,290.17l-5.91,2.12,7,8.21s3.89-2.78,4-6.88Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.36 296.71 403.47 303.23 410.38 300.5 403.36 292.29 397.36 296.71",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.66,192.1c.11.67-.17,1.27-.61,1.34s-.88-.43-1-1.1.17-1.28.61-1.34S369.56,191.42,369.66,192.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.55,193.36a24.53,24.53,0,0,1-2.34,6.26,3.93,3.93,0,0,0,3.31.11Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.48,188a.41.41,0,0,1-.24,0,3.15,3.15,0,0,0-2.89-.09.4.4,0,0,1-.4-.7,4,4,0,0,1,3.65.07.4.4,0,0,1-.12.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,197.73c-1.21,6.19-2.42,17.52,1.91,21.65,0,0-1.69,6.27-13.18,6.27-12.64,0-6-6.27-6-6.27,6.89-1.65,6.72-6.76,5.51-11.57Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.52,222.05c.91-2.36,1.91-5.06-.15-5.91-2.27-.92-14.7-1.87-19-.13s-3.07,6.53-3.07,6.53Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,237.37c-1.44,3.43-3,6.59-4.62,9.83s-3.37,6.38-5.27,9.5a95.32,95.32,0,0,1-6.24,9.23,47.51,47.51,0,0,1-3.85,4.48,26.31,26.31,0,0,1-5.28,4.25l-2,1.19-1.95-.53a16.89,16.89,0,0,1-5.37-2.6,23.78,23.78,0,0,1-3.84-3.44,31.69,31.69,0,0,1-2.93-3.81,29.9,29.9,0,0,1-2.27-4.19l4.91-3.44c1,.74,2.07,1.65,3.11,2.41s2.1,1.52,3.15,2.16a21.3,21.3,0,0,0,3,1.6,8.07,8.07,0,0,0,2.49.63l-4,.66a16.69,16.69,0,0,0,2.68-2.57c.94-1.1,1.89-2.34,2.8-3.65,1.82-2.63,3.53-5.49,5.18-8.41s3.21-5.94,4.74-9,3-6.18,4.42-9.16Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,221.29c7.92,1.82,17,23.42,17,23.42L410.1,255.62a134.06,134.06,0,0,1-10.51-17.87C394.9,227.86,400.9,219.43,409,221.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.33,235.07l7.53,20-.75.52s-3.26-4.57-6.78-10.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.64,221.73s-8,11.15.5,74.07h45.22c.31-6.95-5.05-41.8,1.65-74.51a116.85,116.85,0,0,0-15.14-1.91,166.41,166.41,0,0,0-19.22,0A84.53,84.53,0,0,0,361.64,221.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.66,239.91a40.09,40.09,0,0,1-8.93,19.36c-.18-4-.25-7.69-.24-10.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.56,228.58c1.12,8-14.66,28.46-14.66,28.46l-15.85-10.91s4.4-11.27,11.8-18.66C360.3,219,369.35,219.87,370.56,228.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68,262.76l-6.26-5.05,5.64-6.49a9.64,9.64,0,0,1,5.1,8.51Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.38 254.24 315.21 247.68 320.06 251.22 314.42 257.71 311.38 254.24",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.93,187.24c.75,8.36,1.62,13.21-1.91,18.1-5.32,7.35-16.12,5.11-19.35-2.85-2.91-7.17-3.66-19.63,3.94-24.16A11.45,11.45,0,0,1,391.93,187.24Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.83,
    cy: 192.9,
    rx: 7.96,
    ry: 6.83,
    transform: "translate(84.6 503.59) rotate(-71.38)",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.37,192c-2.85-2.62-2.56-7.14-1.9-8.63-3-.53-12.43-1.3-4.22-10.52s11.65.3,11.65.3,12.48-4.74,14,3.54c7.85-2.06,7.85,17.33-3.92,26.6C380.32,196.54,372.59,195.77,374.37,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.57,190.78a9.52,9.52,0,0,1-2.11,5.71c-1.74,2.12-3.72.95-4.17-1.51-.4-2.21,0-6,2.23-7.2S379.6,188.26,379.57,190.78Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.63,192.34c.66,4.35-1.84,8.33-5.57,8.89s-7.28-2.52-7.93-6.87,1.84-8.33,5.57-8.88S382,188,382.63,192.34Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.57,186.93a1.08,1.08,0,0,1-1-.8c-.07-.28-1.78-7,1.72-11.45,2-2.5,5.16-3.71,9.45-3.61a1.07,1.07,0,0,1-.05,2.14c-3.58-.09-6.19.86-7.72,2.8-2.85,3.6-1.34,9.52-1.33,9.58a1.07,1.07,0,0,1-.76,1.31Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,193.09c.38,2.55-1.08,4.88-3.26,5.2s-4.26-1.47-4.64-4,1.08-4.88,3.26-5.2S377.91,190.55,378.29,193.09Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.88,407.35c-1.09,0-2.13-.15-2.49-.63a.77.77,0,0,1,0-.88,1,1,0,0,1,.64-.47c1.4-.38,4.36,1.3,4.48,1.38a.19.19,0,0,1,.1.2.21.21,0,0,1-.16.17A15.71,15.71,0,0,1,309.88,407.35Zm-1.34-1.64a1.6,1.6,0,0,0-.39.05.61.61,0,0,0-.39.28c-.14.25-.09.37,0,.44.39.55,2.53.56,4.1.34A9,9,0,0,0,308.54,405.71Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.43,407.12l-.08,0c-1-.45-3-2.28-2.89-3.24,0-.22.2-.5.75-.56a1.51,1.51,0,0,1,1.11.34c1.08.89,1.3,3.17,1.31,3.26a.18.18,0,0,1-.08.18A.17.17,0,0,1,312.43,407.12Zm-2.06-3.43h-.12c-.36,0-.38.18-.39.22-.09.58,1.28,2,2.32,2.64a4.77,4.77,0,0,0-1.11-2.61A1.13,1.13,0,0,0,310.37,403.69Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.54 406.92 314.09 406.92 311.62 387.34 320.07 387.34 322.54 406.92",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.33,405.94h9.23a.73.73,0,0,1,.72.58L325,414a1.23,1.23,0,0,1-1.21,1.51c-3.33-.06-8.15-.25-12.33-.25-4.9,0-9.12.26-14.86.26-3.47,0-4.44-3.51-3-3.82,6.62-1.45,12-1.61,17.73-5.13A4,4,0,0,1,313.33,405.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.62 387.35 312.89 397.44 321.35 397.44 320.08 387.35 311.62 387.35",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.76,407.35a2.76,2.76,0,0,1-2-.55.85.85,0,0,1,0-1,.92.92,0,0,1,.63-.46c1.23-.29,3.57,1.31,3.67,1.38a.21.21,0,0,1,.08.2.19.19,0,0,1-.15.15A10.24,10.24,0,0,1,343.76,407.35Zm-1.05-1.61a1,1,0,0,0-.25,0,.55.55,0,0,0-.37.27c-.18.33-.07.47,0,.51.36.48,2.09.48,3.35.27A6.6,6.6,0,0,0,342.71,405.74Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.92,407.12l-.09,0c-.88-.48-2.57-2.33-2.39-3.27a.66.66,0,0,1,.64-.53,1.09,1.09,0,0,1,.85.26c1,.8,1.18,3.24,1.19,3.34a.2.2,0,0,1-.09.19A.2.2,0,0,1,345.92,407.12Zm-1.7-3.43h-.1c-.26,0-.28.15-.29.2-.1.56,1,2,1.84,2.62a4.74,4.74,0,0,0-1-2.65A.72.72,0,0,0,344.22,403.69Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.61 406.92 347.15 406.92 342.9 387.34 351.36 387.34 355.61 406.92",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.55,405.94h9.5a.73.73,0,0,1,.72.58l1.67,7.51a1.25,1.25,0,0,1-1.24,1.51c-3.31-.06-4.92-.25-9.1-.25-2.57,0-5.87.26-9.42.26s-4-3.51-2.56-3.82c6.52-1.43,7-3.39,9.06-5.27A2.05,2.05,0,0,1,346.55,405.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "351.36 387.35 342.9 387.35 345.1 397.44 353.56 397.44 351.36 387.35"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.14,295.8s-64.34,5.7-63.65,38A179,179,0,0,0,310,393.14h12.56s-.64-20.49-.22-53.57c.13-9.92,20.16-13.19,39.72-14.35,16.9-1,32.71-10.63,39.28-26.23l1.34-3.19Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.14,295.8s-64.34,5.7-63.65,38A179,179,0,0,0,310,393.14h12.56s-.64-20.49-.22-53.57c.13-9.92,20.16-13.19,39.72-14.35,16.9-1,32.71-10.63,39.28-26.23l1.34-3.19Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,389.78c-.06,0,.81,6,.81,6h17.42l.47-5.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.69,295.8S328.78,310,327.62,328.87c-2.13,34.7,14.89,64.27,14.89,64.27h12.68s-4.81-14.66-6.54-46.09c-2.17-39.5,72.51.92,58.71-51.25Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.69,295.8S328.78,310,327.62,328.87c-2.13,34.7,14.89,64.27,14.89,64.27h12.68s-4.81-14.66-6.54-46.09c-2.17-39.5,72.51.92,58.71-51.25Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.68,389.78c-.06,0,1.6,6,1.6,6h17.43l-.32-5.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.76,321.8a3.2,3.2,0,0,1,3.2,3.35l-.12,2.77a5.34,5.34,0,0,1-5.09,4.42h-.93l-.92,3.07a4.84,4.84,0,0,1-4.63,3.45H322.89a9.92,9.92,0,0,1,3.39-7.49c0-.08,0-.15,0-.23l-.43-5a4,4,0,0,1,4-4.37Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.76,321.8a3.2,3.2,0,0,1,3.2,3.35l-.12,2.77a5.34,5.34,0,0,1-5.09,4.42h-.93l-.92,3.07a4.84,4.84,0,0,1-4.63,3.45H322.89a9.92,9.92,0,0,1,3.39-7.49c0-.08,0-.15,0-.23l-.43-5a4,4,0,0,1,4-4.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.06 417.57 380.46 417.57 375.81 338.86 372.41 338.86 377.06 417.57",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.06 417.57 380.46 417.57 375.81 338.86 372.41 338.86 377.06 417.57",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.49 417.57 323.09 417.57 327.74 338.86 331.14 338.86 326.49 417.57",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.49 417.57 323.09 417.57 327.74 338.86 331.14 338.86 326.49 417.57",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.34 417.57 401.74 417.57 397.08 338.86 393.69 338.86 398.34 417.57",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.34 417.57 401.74 417.57 397.08 338.86 393.69 338.86 398.34 417.57",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.77 417.57 344.37 417.57 349.02 338.86 352.42 338.86 347.77 417.57",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.77 417.57 344.37 417.57 349.02 338.86 352.42 338.86 347.77 417.57",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.5ed6990a955a5a7eb8eb594698fa8a39.svg";
export { ForwardRef as ReactComponent };